import React, { useState, useRef, useEffect } from 'react';
import TopBar from '../Tools/Topbar';
import LeftSide from '../Tools/LeftSidebar';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';

const SystemConfiguration = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { settings, updateSetting, handleColorTheme } = useSettings();
    const settingsRef = useRef();

    const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div id="main-wrapper">
      <LeftSide isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <TopBar toggleSidebar={toggleSidebar} />

        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}
            />
           <div class="card w-100 position-relative overflow-hidden">
            <div class="px-4 py-3 ">
              <h5 class="card-title fw-semibold mb-0 lh-sm">System Configuration</h5>
              <p class="card-subtitle mb-0 mt-1">System setup and customization panel</p>
            </div>
            <div class="card-body p-4">
              <ul class="nav nav-tabs border-bottom border-primary" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link d-flex active" data-bs-toggle="tab" href="#system-settings" role="tab" aria-selected="true">
                    <span class="d-flex align-items-center"><i class="ti ti-settings fs-5"></i>
                    </span>
                    <span class="d-none d-md-block ms-2">System Settings</span>
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link d-flex" data-bs-toggle="tab" href="#notification-setting" role="tab" aria-selected="false" tabindex="-1">
                    <span><i class="ti ti-bell-ringing fs-5"></i>
                    </span>
                    <span class="d-none d-md-block ms-2">Notification Settings</span>
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link d-flex" data-bs-toggle="tab" href="#integration" role="tab" aria-selected="false" tabindex="-1">
                    <span><i class="ti ti-source-code fs-5"></i>
                    </span>
                    <span class="d-none d-md-block ms-2">Integrations</span>
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link d-flex" data-bs-toggle="tab" href="#data-management-secutity" role="tab" aria-selected="false" tabindex="-1">
                    <span><i class="ti ti-stack-front fs-5"></i></span>
                    <span class="d-none d-md-block ms-2">Data Management & Security</span>
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link d-flex" data-bs-toggle="tab" href="#database-connection" role="tab" aria-selected="false" tabindex="-1">
                    <span><i class="ti ti-database fs-5"></i></span>
                    <span class="d-none d-md-block ms-2">Database Connection</span>
                  </a>
                </li>
              </ul>


              <div class="tab-content">
                <div class="tab-pane active" id="system-settings" role="tabpanel">

                  <div class="data-panel mt-5">
                    <h6 class="px-2 mb-2">Time Zone Settings</h6>
                    <form>
                      <div class="form-group col-lg-4 p-2">
                        <select class="form-control form-select">
                          <option>India Standard Time (IST) – UTC +5:30</option>
                          <option>Central European Time (CET) – UTC +1</option>
                          <option>Greenwich Mean Time (GMT) – UTC +0</option>
                          <option>Eastern Standard Time (EST) – UTC -5</option>
                        </select>
                      </div>
                    </form>
                  </div>

                  <div class="data-panel mt-5">
                    <h6 class="px-2 mb-2">Date Format</h6>
                    <form>
                      <div class="form-group col-lg-12 p-2">
                        <div class="form-check mb-3">
                          <input class="form-check-input primary check-outline outline-primary" type="radio" name="radio-primary" id="primary2-outline-radio" value="option1" checked=""/>
                          <label class="form-check-label " for="primary2-outline-radio">DD/MM/YYYY (e.g., 25/12/2023)  </label>
                        </div>

                        <div class="form-check mb-3">
                          <input class="form-check-input primary check-outline outline-primary" type="radio" name="radio-primary" id="primary-outline-radio" value="option1"/>
                          <label class="form-check-label" for="primary-outline-radio">MM/DD/YYYY (e.g., 12/25/2023)</label>
                        </div>
                        
                        <div class="form-check mb-3">
                          <input class="form-check-input primary check-outline outline-primary" type="radio" name="radio-primary" id="primary3-outline-radio" value="option1"/ >
                          <label class="form-check-label" for="primary3-outline-radio">YYYY-MM-DD (e.g., 2023-12-25)</label>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="data-panel mt-5">
                    <h6 class="px-2 mb-2">Time Format</h6>
                    <form>
                      <div class="form-group col-lg-12 p-2">
                        <div class="form-check mb-3">
                          <input class="form-check-input primary check-outline outline-primary" type="radio" name="radio-primary" id="primary2-outline-radio-12hour" value="option1" checked=""/>
                          <label class="form-check-label " for="primary2-outline-radio-12hour">12-hour (e.g., 2:30 PM)  </label>
                        </div>

                        <div class="form-check mb-3">
                          <input class="form-check-input primary check-outline outline-primary" type="radio" name="radio-primary" id="primary-outline-radio24hour" value="option1"/>
                          <label class="form-check-label" for="primary-outline-radio24hour">24-hour (e.g., 14:30)</label>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="tab-pane p-3" id="notification-setting" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6 my-2 border-end">
                      <div class="data-panel mt-5">
                        <h6 class="px-2 mb-2">Alert Thresholds</h6>
                        <form>
                          <div class="form-group col-lg-6 p-2">
                            <select class="form-control form-select">
                              <option>Specialist Unavailable</option>
                              <option>Capacity Below Threshold</option>
                              <option>High Usage</option>
                              <option>Stock Low</option>
                            </select>
                          </div>
                        </form>
                      </div>

                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-2">Notification Channels</h6>
                        <form class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="web-page-notification" value="option1" checked=""/>
                            <label class="form-check-label" for="web-page-notification">Web-page Notifications</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="email-notification" value="option1"/>
                            <label class="form-check-label" for="email-notification">Email Notifications</label>
                          </div>
                          
                        </form>
                      </div>

                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-2">Recipient Management</h6>
                        <form class="p-2">
                          <div class="row m-0">
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option1" value="option1" checked=""/>
                              <label class="form-check-label" for="option1">Ethan</label>
                            </div>
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option2" value="option1"/>
                              <label class="form-check-label" for="option2">Charlotte</label>
                            </div>
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option3" value="option1"/>
                              <label class="form-check-label" for="option3">Ethan</label>
                            </div>
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option4" value="option1"/>
                              <label class="form-check-label" for="option4">Noah</label>
                            </div>
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option5" value="option1"/>
                              <label class="form-check-label" for="option5">Liam</label>
                            </div>
                            <div class="form-check col-sm-6 mb-3">
                              <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="option6" value="option1"/>
                              <label class="form-check-label" for="option6">Amelia</label>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-2">Notification Templates</h6>
                        <form class="p-2">
                          <div class="form-group mb-3">
                            <label>Title: </label>
                            <input type="text" class="form-control"/>
                          </div>
                          <div class="form-group mb-3">
                            <label>Message </label>
                            <textarea class="form-control" rows="3"></textarea>
                          </div>
                          <button type="submit" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                            Save
                          </button>
                        </form>
                      </div>
                    </div>

                    <div class="col-lg-6 my-2">
                      <div class="data-panel mt-5">
                        <h6 class="px-2 mb-2">Contact Us</h6>
                        <h6 class="px-2 mt-4 mb-3">Recipient </h6>
                        <form class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="checkbox" id="user1" value="option1" checked=""/>
                            <label class="form-check-label" for="user1">maha.b.najm@gmail.com</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="checkbox" id="user2" value="option1"/>
                            <label class="form-check-label" for="user2">anas631@gmail.com</label>
                          </div>
                        </form>
                      </div>

                      <div class="data-panel mt-5">
                        <h6 class="px-2 mb-3">Notification Templates</h6>
                        <form class="p-2">
                          <div class="form-group mb-3">
                            <label>Subject Line: </label>
                            <input type="text" class="form-control"/>
                          </div>
                          <div class="form-group mb-3">
                            <label>Message Body: </label>
                            <textarea class="form-control" rows="3"></textarea>
                          </div>
                          <button type="submit" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                            Save
                          </button>
                        </form>
                      </div>
                    </div>

                    <div class="col-12 border-top">
                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-2">Configurable Alerts</h6>
                        <form class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="shortage-in-specialty" value="option1" checked=""/>
                            <label class="form-check-label" for="shortage-in-specialty">Shortage in Specialty</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="shortage-in-assets" value="option1"/>
                            <label class="form-check-label" for="shortage-in-assets">Shortage in Assets</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary check-outline outline-primary" type="checkbox" id="capacity-usage-threshold" value="option1"/>
                            <label class="form-check-label" for="capacity-usage-threshold">Capacity Usage Threshold</label>
                          </div>
                          <button type="submit" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                            Save
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane p-3" id="integration" role="tabpanel">

                </div>
                <div class="tab-pane p-3" id="data-management-secutity" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6 my-2 border-end">
                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-4">Data Retention</h6>

                        <div class="row mb-3 mx-0">
                          <div class="col-lg-4">
                            <label>Data Retention Tenure:</label>
                          </div>
                          <div class="col-lg-8">
                            <select class="form-select col-12" id="inlineFormCustomSelect">
                              <option selected="">6 month</option>
                              <option value="1">One Year</option>
                              <option value="2">Two Year</option>
                              <option value="3">Three Year</option>
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3 mx-0">
                          <div class="col-lg-4">
                            <label>Backup Schedule</label>
                          </div>
                          <div class="col-lg-8">
                            <select class="form-select col-12" id="inlineFormCustomSelect">
                              <option selected="">Weekly</option>
                              <option value="1">Month</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="data-panel mt-5">
                        <h6 class="px-2 mb-4">Data Backups Destination</h6>

                        <div class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="local-storage"/>
                            <label class="form-check-label" for="flexCheckDefault">
                              Local Storage     
                            </label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="cloud-storage" checked/>
                            <label class="form-check-label" for="flexCheckChecked">
                              Cloud Storage 
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="data-panel">
                        <div class="p-2">
                          <form>
                            <div class="form-group mb-4">
                                <label class="mr-sm-2 mb-3" for="inlineFormCustomSelect">Select Provider</label>
                                <select class="form-select mr-sm-2" id="inlineFormCustomSelect">
                                    <option selected>Google Drive</option>
                                    <option value="1">AWS</option>
                                    <option value="2">Amazon Server</option>
                                </select>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 my-2">
                      <div class="data-panel mt-4">
                        <h6 class="px-2 mb-4">Security Settings</h6>

                        <h6 class="px-2 mb-4">Password Policies</h6>
                        <div class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="checktoption1"/>
                            <label class="form-check-label" for="checktoption1">
                              Must contain at least 8 characters
                            </label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="checktoption2" checked/>
                            <label class="form-check-label" for="checktoption2">
                              Must include at least one symbol (e.g., !@#$)
                            </label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="checktoption3" checked/>
                            <label class="form-check-label" for="checktoption3">
                              Must include at least one number (0-9)
                            </label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="checktoption4" checked/>
                            <label class="form-check-label" for="checktoption4">
                              Must include both uppercase and lowercase
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="data-panel mt-5">
                        <h6 class="px-2 mb-4">Session Timeout Settings</h6>

                        <h6 class="px-2 mb-4">Inactivity Timeout:</h6>
                        <div class="p-2">
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="radio" name="radio-solid-primary" id="timeout1" value="option1" checked=""/>
                            <label class="form-check-label" for="timeout1">30 minutes</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="radio" name="radio-solid-primary" id="timeout2" value="option1"/>
                            <label class="form-check-label" for="timeout2">15 minutes</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="radio" name="radio-solid-primary" id="timeout3" value="option1"/>
                            <label class="form-check-label" for="timeout3">1 hour</label>
                          </div>
                          <div class="form-check mb-3">
                            <input class="form-check-input primary" type="radio" name="radio-solid-primary" id="timeout4" value="option1"/>
                            <label class="form-check-label" for="timeout4">2 hour</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane p-3" id="database-connection" role="tabpanel">
                <div class="col-lg-6 my-2 ">
                  <div class="data-panel mt-4">
                    <h6 class="px-2 mb-4">Data Connection</h6>

                    <div class="px-2">
                      <div class="mb-3">
                        <label>Host/Server Name</label>
                        <input type="text" class="form-control"/>
                      </div>

                      <div class="mb-3">
                        <label>Port</label>
                        <input type="text" class="form-control"/>
                      </div>

                      <div class="mb-3">
                        <label>Database Name</label>
                        <input type="text" class="form-control"/>
                      </div>

                      <div class="mb-3">
                        <label>Username</label>
                        <input type="text" class="form-control"/>
                      </div>

                      <div class="mb-3">
                        <label>Password</label>
                        <input type="text" class="form-control"/>
                      </div>

                      <button type="button" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                        Test Connection 
                      </button>
                    </div>  
                  </div>
                </div>    
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
</div>
  );
};

export default SystemConfiguration;